module.exports = __webpack_public_path__ + "img/loading.afb41021.svg";